<template>
  <html>

  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
    <meta name="mobile-web-app-capable" content="yes" />
    <meta name="apple-mobile-web-app-capable" content="yes" />
    <link rel="icon" type="image/png" href="favicon.png" />
    <title>Restó APP</title>
  </head>

  <body class="home-page">
    <Header :isRestoCompleto="this.pasosCompletados == 8?true:false"/>
    <div class="col-lg-8 mx-auto p-3 py-md-5">
      <main>
        <h3>Cambiar datos de la cuenta</h3>

<hr class="" />


<form v-on:submit.prevent="modificarUsuario">
  <div class="mb-4 row">
              <label class="col-sm-4 col-form-label">E-Mail</label>
              <div class="col-sm-8">
                <input
                  :placeholder="email"
                  v-model="email"
                  type="text"
                  class="form-control"
                  disabled
                />
              </div>
            </div>

            <div class="mb-4 row">
              <label class="col-sm-4 col-form-label">Nombre</label>
              <div class="col-sm-8">
                <input
                  :placeholder="nombre"
                  v-model="nombre"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>

            <div class="mb-4 row">
              <label class="col-sm-4 col-form-label">Apellido</label>
              <div class="col-sm-8">
                <input
                  :placeholder="apellido"
                  v-model="apellido"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>

            <div class="mb-4 row">
              <label class="col-sm-4 col-form-label">Telefono</label>
              <div class="col-sm-8">
                <input
                  :placeholder="telefono"
                  v-model="telefono"
                  type="text"
                  class="form-control"
                  disabled
                />
              </div>
            </div>

            <div class="alert alert-danger" role="alert" v-if="error">
              {{ error_msg }}
            </div>
            <div class="alert alert-success" role="alert" v-if="success">
              {{ success_msg }}
            </div>
            <div class="mb-4 row">

              <div class="col-sm-6"><button type="button"  class="btn btn-primary" 
                @click="recovery()" 
                >Cambiar Contraseña</button>
              
            </div>

            <div class="col-sm-6">
              <button class="btn btn-primary" type="submit">
                Guardar cambios
              </button>
            </div>
            </div>

           


          </form>


<PopUpSinCerrar :show="cargando">
              <template #body>
                <p>{{ cargando_msg }}</p>
              </template>
            </PopUpSinCerrar>

      </main>
      <Footer />
    </div>
  </body>

  </html>
</template>

<script>


import "vue2-datepicker/index.css";
import axios from "axios";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import PopUpSinCerrar from "../components/PopUpSinCerrar.vue";
export default {
  name: "MiPerfil",
  components: { Header, Footer ,PopUpSinCerrar },
  data: function () {
    return {
      filename: "",
      fechaRegistro: "",
      fechaReserva: "",
      estados: [],
      estadoSelec: "",
      email: "",
      telefono: "",
      compras: [],
      filtrados: [],
      error: false,
      error_msg: "",
      success: false,
      success_msg: "",
      currentPage: 1,
      pageSize: 10,
      pageSizeSelected: 10,
      totalRows: 0,
      cargando_msg:"",
      cargando:false,
      busqueda:"",
      cantidadVencer:0,
      cantidadSinVencer:0,
      nombre:"",
      apellido:"",
      pasosCompletados: 8,
    };
  },
  methods: {
    recovery() {
      let json = {
        email: this.email,
      };

       axios
        .post("/reset-user-init", json)
        .then((data) => {
          if (data.status == 200) {
            this.success = true;
            this.success_msg = "Enviaremos un link de acceso a tu correo electrónico para que puedas modificar tu contraseña";
          }
        })
    },
    modificarUsuario() {
      let json = {
        email: this.email,
        nombre: this.nombre,
        apellido: this.apellido,
        telefono: this.telefono,
        usuario_id: this.usuario_id,
      };
      axios.post("/updateUser", json).then((data) => {
        if (data.status == 200) {
          this.success = true;
          this.success_msg = "Informacion del restaurante guardada con exito!";
        }
      });
    },
  
  },

  beforeMount() {
    axios
      .get("/getUsuario")
      .then((data) => {
        console.log(data)
        if (data.status == 200) {
          this.usuario_id = data.data.usuario_id;
          this.email=data.data.mail;
          this.nombre=data.data.nombre;
          this.apellido=data.data.apellido;
          this.telefono=data.data.telefono;
        }
      })
      .catch((w) => {
        console.log(w);
        this.error = true;
        this.error_msg =
          "No se ha podido actualizar la informacion. Vuelva a intentar mas tarde";
      });
    
  },
};
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");

:host {
  --main-color: #0047b3;
  --second-color: #0198f3;
  --grey-color: #f5f8fa;
  --border-radius-1: 9px;
  --border-radius-2: 6px;
}

body {
  font-family: "Inter", sans-serif;
  color: #083744;
  font-size: 14px;
  height: 100%;
}
</style>
